import '../css/FieldItem.css'

export const FieldItem = ({field, question}) => {
    // console.log(`Question: ${question.key}: ${field[question.key]}`);
    return <li className={question.cssClassName()}><strong>{question.title}</strong>: {question.displayableValue(field)}</li>
}
